import React, { Component } from "react";

import "./index.css";

import { MDBRow, MDBCol } from "mdbreact";
import { NavLink, withRouter } from "react-router-dom";
import {
  RiArrowDownSLine,
  RiArrowUpSLine,
  RiArrowRightSLine,
  RiCloseLine,
} from "react-icons/ri";
import mixpanel from "mixpanel-browser";
import { HiLightningBolt, HiSortAscending } from "react-icons/hi";

import { TiTick } from "react-icons/ti";
import VisibilitySensor from "react-visibility-sensor";
import { IoSearch, IoLocationSharp, IoArrowUp } from "react-icons/io5";
import Scroll from "react-scroll";

const scroll = Scroll.animateScroll;

class FAQ extends Component {
  constructor(props) {
    super(props);

    this.state = {
      querySellers: [],
      isStopped: false,
      isPaused: false,
    };
  }

  render() {
    console.log(this.props.version);

    return (
      <>
        <MDBCol className="d-flex justify-content-center" size="12">
          <p
            ref={this.myRef1}
            style={{
              fontFamily: "PlusJSExtraBold",
              marginTop: 0,
              fontSize: 40,
              fontWeight: "600",
              textAlign: "center",
            }}
          >
            Questions? We have answers.
          </p>
        </MDBCol>

        <MDBCol style={{ paddingLeft: "12%" }} size="6">
          <p
            ref={this.myRef1}
            style={{
              fontFamily: "PlusJSExtraBold",
              marginTop: 40,
              fontSize: 18,
              fontWeight: "600",
            }}
          >
            What is YouDub?
          </p>
          <p
            style={{
              fontFamily: "PlusJSMedium",
              fontSize: 15,
              opacity: 0.7,
              fontWeight: "400",
              marginTop: -5,
              width: "90%",
            }}
          >
            YouDub is an innovative platform that specializes in the automatic
            dubbing of videos and podcasts. It utilizes advanced AI technology
            to seamlessly generate dubbed versions of videos, enabling content
            creators to reach a broader audience.
          </p>
        </MDBCol>
        <MDBCol style={{ paddingRight: "3%" }} size="6">
          <p
            ref={this.myRef1}
            style={{
              fontFamily: "PlusJSExtraBold",
              marginTop: 40,
              fontSize: 18,
              fontWeight: "600",
            }}
          >
            {" "}
            How does YouDub work?
          </p>
          <p
            style={{
              fontFamily: "PlusJSMedium",
              fontSize: 15,
              opacity: 0.7,
              fontWeight: "400",
              marginTop: -5,
              width: "90%",
            }}
          >
            {" "}
            YouDub employs state-of-the-art algorithms to analyze and transcribe
            the audio content of videos. It then generates accurate translations
            and synchronizes them with the original video, creating high-quality
            dubbed versions in different languages or accents.
          </p>
        </MDBCol>
        <MDBCol style={{ paddingLeft: "12%" }} size="6">
          <p
            ref={this.myRef1}
            style={{
              fontFamily: "PlusJSExtraBold",
              marginTop: 40,
              fontSize: 18,
              fontWeight: "600",
            }}
          >
            {" "}
            Why should I use YouDub?
          </p>
          <p
            style={{
              fontFamily: "PlusJSMedium",
              fontSize: 15,
              opacity: 0.7,
              fontWeight: "400",
              marginTop: -5,
              width: "90%",
            }}
          >
            {" "}
            By using YouDub, content creators can expand their viewership by
            making their videos accessible to international audiences. The
            platform saves time and resources by automating the dubbing process,
            eliminating the need for manual translation and recording.
          </p>
        </MDBCol>
        <MDBCol style={{ paddingRight: "3%" }} size="6">
          <p
            ref={this.myRef1}
            style={{
              fontFamily: "PlusJSExtraBold",
              marginTop: 40,
              fontSize: 18,
              fontWeight: "600",
            }}
          >
            {" "}
            How long does it take to get set up?
          </p>
          <p
            style={{
              fontFamily: "PlusJSMedium",
              fontSize: 15,
              opacity: 0.7,
              fontWeight: "400",
              marginTop: -5,
              width: "90%",
            }}
          >
            {" "}
            The dubbing process duration can vary depending on factors such as
            the video length, complexity, and server load. In general, YouDub
            strives to provide fast turnaround times, ensuring that your dubbed
            videos are available within a reasonable timeframe.
          </p>
        </MDBCol>
        <MDBCol style={{ paddingLeft: "12%" }} size="6">
          <p
            ref={this.myRef1}
            style={{
              fontFamily: "PlusJSExtraBold",
              marginTop: 40,
              fontSize: 18,
              fontWeight: "600",
            }}
          >
            Is there a free trial?
          </p>
          <p
            style={{
              fontFamily: "PlusJSMedium",
              fontSize: 15,
              opacity: 0.7,
              fontWeight: "400",
              marginTop: -5,
              width: "90%",
            }}
          >
            Yes, YouDub offers a trial period for content creators to experience
            the platform's features and evaluate its suitability for their
            needs. During the trial, you can test the dubbing capabilities and
            assess the quality of the output.
          </p>
        </MDBCol>
        <MDBCol style={{ paddingRight: "3%" }} size="6">
          <p
            ref={this.myRef1}
            style={{
              fontFamily: "PlusJSExtraBold",
              marginTop: 40,
              fontSize: 18,
              fontWeight: "600",
            }}
          >
            What is the pricing for YouDub?
          </p>
          <p
            style={{
              fontFamily: "PlusJSMedium",
              fontSize: 15,
              opacity: 0.7,
              fontWeight: "400",
              marginTop: -5,
              width: "90%",
            }}
          >
            YouDub offers flexible pricing plans tailored to the needs of
            content creators. The pricing may depend on factors such as the
            duration of the videos, the number of languages/accents required,
            and the volume of videos processed. Contact our sales team to get
            detailed pricing information.
          </p>
        </MDBCol>
      </>
    );
  }
}

export default withRouter(FAQ);
